import { master_defaults, overrides } from './data';

const currentTenant = process.env.REACT_APP_TENANT || 'default';

export const features = {
    ...master_defaults,
    ...(overrides[currentTenant] || {}),
};
